<script lang="ts">
  import { t } from '../../lib/i18n/index.svelte.js'
  import type { ListStore } from '../../lib/state/listStore.svelte.js'

  interface Props {
    store: ListStore
  }
  const { store }: Props = $props()

  let showSaving = $state(false)

  // Only surface "saving" when it takes long enough to be worth mentioning.
  $effect(() => {
    if (!store.saving) {
      showSaving = false
      return
    }
    const timer = setTimeout(() => (showSaving = true), 2000)
    return () => clearTimeout(timer)
  })

  const mode = $derived(
    store.connection === 'offline'
      ? 'offline'
      : showSaving
        ? 'saving'
        : store.connection === 'reconnecting'
          ? 'reconnecting'
          : 'live',
  )
  const label = $derived(
    mode === 'saving'
      ? t('connection_saving')
      : mode === 'reconnecting'
        ? t('connection_reconnecting')
        : t('connection_live'),
  )
</script>

{#if mode !== 'offline'}
  <div class="chip {mode}" title={label}>
    <span class="dot" aria-hidden="true"></span>
    {#if mode !== 'live'}<span class="text">{label}</span>{/if}
    <span class="visually-hidden">{label}</span>
  </div>
{/if}

<style>
  .chip {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    padding: 0 var(--space-2);
    font-size: 13px;
    color: var(--fg-muted);
  }
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--accent);
  }
  .saving .dot,
  .reconnecting .dot {
    background: var(--warn);
    animation: blink 1.2s infinite;
  }
  @keyframes blink {
    50% {
      opacity: 0.3;
    }
  }
</style>
